"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from "react";
import HoverCard from "./HoverCard";
import UserProfileTooltip from "@/components/user/utils/profile/UserProfileTooltip";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { WaveCreatorPreviewModal } from "@/components/waves/drops/WaveCreatorPreviewModal";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import type { ArtistPreviewTab } from "@/hooks/useArtistPreviewModal";
interface UserProfileTooltipWrapperProps {
  readonly user: string;
  readonly children: React.ReactElement;
  readonly placement?: "top" | "bottom" | "left" | "right" | "auto" | undefined;
}
export default function UserProfileTooltipWrapper(t0) {
  const $ = _c(24);
  const {
    user,
    children,
    placement: t1
  } = t0;
  const placement = t1 === undefined ? "auto" : t1;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t2;
  if ($[0] !== user) {
    t2 = user.trim();
    $[0] = user;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const trimmedUser = t2;
  const ariaLabel = trimmedUser ? `User profile for ${trimmedUser}` : "User profile";
  const [artistPreview, setArtistPreview] = useState(null);
  const [waveCreatorUser, setWaveCreatorUser] = useState(null);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = params => {
      setWaveCreatorUser(null);
      setArtistPreview({
        user: params.user,
        activeTab: params.initialTab
      });
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleArtistPreviewOpen = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = tab => {
      setArtistPreview(current => {
        if (current === null || current.activeTab === tab) {
          return current;
        }
        return {
          ...current,
          activeTab: tab
        };
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleArtistPreviewTabChange = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setArtistPreview(null);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleArtistPreviewClose = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = modalUser => {
      setArtistPreview(null);
      setWaveCreatorUser(modalUser);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleWaveCreatorPreviewOpen = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setWaveCreatorUser(null);
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const handleWaveCreatorPreviewClose = t7;
  if (hasTouchScreen) {
    let t8;
    if ($[7] !== children) {
      t8 = <>{children}</>;
      $[7] = children;
      $[8] = t8;
    } else {
      t8 = $[8];
    }
    return t8;
  }
  let t8;
  if ($[9] !== user) {
    t8 = <UserProfileTooltip user={user} onArtistPreviewOpen={handleArtistPreviewOpen} onWaveCreatorPreviewOpen={handleWaveCreatorPreviewOpen} />;
    $[9] = user;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== ariaLabel || $[12] !== children || $[13] !== placement || $[14] !== t8) {
    t9 = <HoverCard content={t8} ariaLabel={ariaLabel} placement={placement} delayShow={500} delayHide={0}>{children}</HoverCard>;
    $[11] = ariaLabel;
    $[12] = children;
    $[13] = placement;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== artistPreview) {
    t10 = artistPreview && <ArtistPreviewModal isOpen={true} onClose={handleArtistPreviewClose} user={artistPreview.user} activeTab={artistPreview.activeTab} onTabChange={handleArtistPreviewTabChange} />;
    $[16] = artistPreview;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== waveCreatorUser) {
    t11 = waveCreatorUser && <WaveCreatorPreviewModal isOpen={true} onClose={handleWaveCreatorPreviewClose} user={waveCreatorUser} />;
    $[18] = waveCreatorUser;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t9) {
    t12 = <>{t9}{t10}{t11}</>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}